import { useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSupportUnread } from "@/hooks/useSupportUnread";
import { tr } from "@/lib/tr";

export function SupportButton() {
  const navigate = useNavigate();
  // Unread = support replied after the customer's last read of that ticket
  const { unreadCount } = useSupportUnread(false, true);

  const label = tr("الدعم الفني", "Support", "Support");
  const hasUnread = unreadCount > 0;

  return (
    <Button
      variant="ghost"
      onClick={() => navigate("/support")}
      aria-label={label}
      title={label}
      className="shrink-0 relative gap-2 px-2 sm:px-3 text-support hover:text-support hover:bg-support/10"
    >
      <MessageCircle className="h-4 w-4" />
      <span className="hidden lg:inline text-sm font-medium">{label}</span>
      {hasUnread && (
        <span
          className="absolute top-0.5 end-0.5 min-w-[1.05rem] h-[1.05rem] px-1 rounded-full bg-destructive text-destructive-foreground text-[10px] font-bold leading-[1.05rem] text-center ring-2 ring-card"
          aria-label={tr("ردود جديدة", "New replies", "Nouvelles réponses", "نئے جوابات")}
        >
          {unreadCount > 9 ? "9+" : unreadCount}
        </span>
      )}
    </Button>
  );
}
